<template>
    <router-link :to="`/media/${item.post_name}`" class="media-photo group block flex flex-col">

        <div class="stack-icon transition-all duration-300 ease-in-out group-hover:scale-110 scale-80 opacity-75 group-hover:opacity-100 flex items-center justify-center drop-shadow z-[5] absolute w-full h-[180px] text-white left-0 top-0">
            <PhotoIcon class="w-8 h-8" />
        </div>

        <div class="photo-stack">
            <div class="photo-stack-item" v-for="photo in imageSet" :key="photo">
                <img :src="photo.medium" :alt="photo.caption">
            </div>
        </div>

        <div class="photo-details px-6 pt-5 pb-4">
            <h3 class="text-slate-600 text-[.92rem] uppercase font-medium antialiased transition-colors duration-300 group-hover:text-[#0F81AB]" v-html="item.post_title"></h3>
            <h4 class="text-[.85rem] italic mt-0.5 text-slate-500">{{ item.photo_set.length }} Slides</h4>
        </div>



    </router-link>
</template>
<script setup>
    import { computed } from 'vue';

    import { RouterLink } from 'vue-router';

    import { PhotoIcon } from '@heroicons/vue/24/outline'


    const props = defineProps({
        item: {
            type: Object,
            default: {}
        }
    })

    const imageSet = computed(() => {
        return props.item.photo_set.slice(0, 3);
    })

</script>
<style lang="postcss">



</style>
